import {IReportMeasurement} from "Data";

export class OptimizationHelper {
    static strokeCanBeOptimized(stroke: IReportMeasurement | undefined): boolean {
        if(!stroke)
            return false;

        if (this.isNotEmpty(stroke.club) && this.isNotEmpty(stroke.carry) && this.isNotEmpty(stroke.total) && this.isNotEmpty(stroke.height) && this.isNotEmpty(stroke.clubSpeed) && this.isNotEmpty(stroke.ballSpeed) && this.isNotEmpty(stroke.launchAngle)) {
            if (stroke.club === "Driver") {
                if (this.isNotEmpty(stroke.attackAngle)) {
                    return true;
                }
            } else {
                return true;
            }
        }
        return false;
    }

    static isNotEmpty(value: any) {
        return (value != null && value !== '');
    }
}